<template>
  <div class="w-full">
    <div class="w-full">
      <LeftCard />
    </div>
    <div class="w-full mt-4">
      <RightTable />
    </div>
  </div>
</template>
<script>
import LeftCard from "./LeftCard";
import RightTable from "./RightTable";
export default {
  components: {
    LeftCard,
    RightTable,
  },
};
</script>
